import type { SavedSearchCadence } from '@/types/savedSearch';

/**
 * Napis dzwonka alertów obok „Moje filtry” (podpowiedź i aria-label): „Alerty e-mail: codziennie”
 * albo „Alerty e-mail: wyłączone”. Kadencja to te same nazwy co karty w Ustawieniach
 * (`settings.flat_alerts.cadence_*_title`), po dwukropku małą literą, jak „…: wyłączone”.
 */
export function etykietaDzwonka(
  t: (k: string, o?: Record<string, unknown>) => string,
  alerty: { enabled: boolean; cadence: SavedSearchCadence },
  jezyk: string,
): string {
  if (!alerty.enabled) return t('search.my_filters.alerts_bell_off');
  const kadencja = t(`settings.flat_alerts.cadence_${alerty.cadence}_title`);
  const malaLitera = kadencja.charAt(0).toLocaleLowerCase(jezyk) + kadencja.slice(1);
  return t('search.my_filters.alerts_bell_on', { cadence: malaLitera });
}
